import { Box, Divider, Grid, makeStyles, useMediaQuery, useTheme } from "@material-ui/core";
import { Skeleton } from "@material-ui/lab";
import React, { Fragment } from "react";
import styled from "styled-components";
const Card = styled(Skeleton) `
  width: 100%;
  padding-top: 145%;

  &.MuiSkeleton-root {
    height: auto;
  }
`;
const Title = styled(Skeleton) `
  width: 100%;
  height: 42px;

  &.MuiSkeleton-root {
    padding: 0;
  }
`;
const Meta = styled.div `
  padding-top: 14px;
  display: flex;

  .MuiSkeleton-root + .MuiSkeleton-root {
    margin-left: 8px;
  }
`;
const useStyles = makeStyles((theme) => ({
    WideCardFeed: {
        "& > *:nth-child(1)": {
            marginLeft: 0
        }
    }
}));
const PlaceholderCard = (props) => (React.createElement(Box, { width: props.isMobile ? 246 / 1.3 : 246, margin: "12px 24px 12px 0", flexShrink: 0 },
    React.createElement(Card, { variant: "rect" }),
    React.createElement(Meta, null,
        React.createElement(Skeleton, { variant: "text", width: "20%" }),
        React.createElement(Skeleton, { variant: "text", width: "35%" }),
        React.createElement(Skeleton, { variant: "text", width: "28%" }))));
const PlaceholderInstructorCard = () => (React.createElement(Box, { width: "100%", margin: "12px 24px 12px 0" },
    React.createElement(Card, { variant: "rect", style: { paddingTop: "100%" } }),
    React.createElement(Meta, null,
        React.createElement(Skeleton, { variant: "text", width: "50%" }))));
const PlaceholderTitle = () => (React.createElement(Box, { width: "140px" },
    React.createElement(Title, { variant: "text" })));
const PlaceholderReplay = () => (React.createElement(Box, { width: "100%", margin: "12px" },
    React.createElement(Card, { variant: "rect", style: { paddingTop: "56.25%" } })));
const ScheduledSessionCardListPlaceholder = (props) => {
    return (React.createElement(Grid, { style: { margin: "8px 0" }, container: true, direction: "row", spacing: 2 },
        React.createElement(Grid, { style: { paddingLeft: 0 }, item: true },
            React.createElement(Skeleton, { variant: "rect", height: "70px", width: "70px" })),
        React.createElement(Grid, { item: true },
            React.createElement(Skeleton, { variant: "text", width: "100px", height: "19px" }),
            React.createElement(Skeleton, { variant: "text", width: "130px", height: "26px" }))));
};
const CategoryPicker = (props) => {
    return React.createElement(Skeleton, { variant: "text", width: "100%", height: "60px" });
};
const RecruitmentAvatars = (props) => {
    return React.createElement(Skeleton, { variant: "text", width: "calc(100% - 20px)", height: "84px" });
};
const InstructorFeed = (props) => {
    const { rows, cards } = props;
    const mockRows = [...Array(rows).keys()].map((x) => {
        return { id: x };
    });
    const mockCards = [...Array(cards).keys()].map((x) => {
        return { id: x };
    });
    return (React.createElement(React.Fragment, null, mockRows.map((row) => (React.createElement(Box, { display: "flex", width: "100%", mb: cards < 3 ? "32px" : "48px", key: row.id }, mockCards.map((card) => (React.createElement(PlaceholderInstructorCard, { key: card.id }))))))));
};
const ListFeed = (props) => {
    const { rows, cards } = props;
    const mockListContainers = [...Array(rows).keys()].map((x) => {
        return { id: x };
    });
    const mockListItems = [...Array(cards).keys()].map((x) => {
        return { id: x };
    });
    return (React.createElement(React.Fragment, null, mockListContainers.map((listContainer) => (React.createElement(Box, { key: listContainer.id, mb: "48px" },
        React.createElement(PlaceholderTitle, null),
        mockListItems.map((listItem) => (React.createElement(Fragment, { key: listItem.id },
            React.createElement(ScheduledSessionCardListPlaceholder, null),
            React.createElement(Divider, null)))))))));
};
const CardFeed = (props) => {
    const { rows, cards } = props;
    const theme = useTheme();
    const isMobile = useMediaQuery(theme.breakpoints.down("xs"));
    const mockRows = [...Array(rows).keys()].map((x) => {
        return { id: x };
    });
    const mockCards = [...Array(cards).keys()].map((x) => {
        return { id: x };
    });
    return (React.createElement(React.Fragment, null, mockRows.map((row) => (React.createElement(Box, { key: row.id, mb: `${isMobile ? "8px" : "12px"}` },
        React.createElement(PlaceholderTitle, null),
        React.createElement(Box, { width: "100%", display: "flex" }, mockCards.map((card) => (React.createElement(PlaceholderCard, { key: card.id, isMobile: isMobile })))))))));
};
const WideCardFeed = (props) => {
    const { rows, cards } = props;
    const theme = useTheme();
    const isMobile = useMediaQuery(theme.breakpoints.down("xs"));
    const classes = useStyles();
    const mockRows = [...Array(rows).keys()].map((x) => {
        return { id: x };
    });
    const mockCards = [...Array(cards).keys()].map((x) => {
        return { id: x };
    });
    return (React.createElement(React.Fragment, null, mockRows.map((row) => (React.createElement(Box, { key: row.id, mb: `${isMobile ? "8px" : "12px"}` },
        React.createElement(PlaceholderTitle, null),
        React.createElement(Box, { width: "100%", display: "flex", className: classes.WideCardFeed }, mockCards.map((card) => (React.createElement(PlaceholderReplay, { key: card.id })))))))));
};
const Replay = (props) => {
    return (React.createElement(Box, { mb: "48px" },
        React.createElement(PlaceholderTitle, null),
        React.createElement(Box, { width: "100%", display: "flex" },
            React.createElement(PlaceholderReplay, null))));
};
export const Placeholder = {
    CategoryPicker,
    InstructorFeed,
    ListFeed,
    CardFeed,
    WideCardFeed,
    Replay,
    RecruitmentAvatars
};
//# sourceMappingURL=index.js.map